// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"KendoFilterGridModal_Dialog__3YBGh","Button":"KendoFilterGridModal_Button__2VoUS"};